(() => {
    if (!window.visualViewport) {
        return;
    }

    const isIOS =
        /iP(ad|hone|od)/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (!isIOS) {
        return;
    }

    const heightClassSuffixes = ['h-screen', 'h-[100vh]', 'h-[90vh]', 'min-h-screen', 'min-h-[100vh]'];
    const selector = heightClassSuffixes.map(suffix => `[class*="${suffix}"]`).join(',');
    const adjusted = new Map();
    let rafId = null;

    const restore = () => {
        for (const [element, styles] of adjusted.entries()) {
            element.style.height = styles.height;
            element.style.minHeight = styles.minHeight;
        }
        adjusted.clear();
        document.documentElement.classList.remove('ios-keyboard-open');
        document.documentElement.style.removeProperty('--ios-keyboard-height');
    };

    const update = () => {
        const viewport = window.visualViewport;
        const keyboardHeight = Math.max(
            document.documentElement.clientHeight - viewport.height - viewport.offsetTop,
            0
        );
        const keyboardOpen = keyboardHeight > 100;

        if (!keyboardOpen) {
            restore();
            return;
        }

        document.documentElement.classList.add('ios-keyboard-open');
        document.documentElement.style.setProperty('--ios-keyboard-height', `${Math.round(keyboardHeight)}px`);

        const targetHeight = Math.round(viewport.height);
        const targets = document.querySelectorAll(selector);

        for (const element of targets) {
            let adjustHeight = false;
            let adjustMinHeight = false;

            for (const cls of element.classList) {
                if (cls.endsWith('h-screen') || cls.endsWith('h-[100vh]') || cls.endsWith('h-[90vh]')) {
                    adjustHeight = true;
                }
                if (cls.endsWith('min-h-screen') || cls.endsWith('min-h-[100vh]')) {
                    adjustMinHeight = true;
                }
            }

            if (!adjustHeight && !adjustMinHeight) {
                continue;
            }

            if (!adjusted.has(element)) {
                adjusted.set(element, {
                    height: element.style.height,
                    minHeight: element.style.minHeight,
                });
            }

            if (adjustHeight) {
                element.style.height = `${targetHeight}px`;
            }
            if (adjustMinHeight) {
                element.style.minHeight = `${targetHeight}px`;
            }
        }
    };

    const schedule = () => {
        if (rafId !== null) {
            return;
        }
        rafId = window.requestAnimationFrame(() => {
            rafId = null;
            update();
        });
    };

    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule);
    window.addEventListener('orientationchange', schedule);
    window.addEventListener('focusin', schedule);
    window.addEventListener('focusout', schedule);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
        schedule();
    }
})();
